import {
	GetVendorPurchaseOrderQuery,
	GetVendorPurchaseOrdersQuery
} from "~/gql/queries/vendorPurchaseOrders.generated";

export const vendorPurchaseOrderEndpoints = {
	GetVendorPurchaseOrder: {
		providesTags: ["VendorPurchaseOrders"] as AddTagTypes,
		transformResponse: (res: GetVendorPurchaseOrderQuery) => res
	},
	GetVendorPurchaseOrders: {
		providesTags: ["VendorPurchaseOrders"] as AddTagTypes,
		transformResponse: (res: GetVendorPurchaseOrdersQuery) => res
	}
};
